import './index.erb';
import './index.rb';

(function ($) {
  $(document).on('click', '#c-nudge__cta', function () {
    const featureName = $(this).data('feature-name');

    if (featureName) {
      UserTracker.emit('event', {
        eventName: 'feature intervention clicked',
        data: {
          'feature name': featureName,
          'request path': window.location.pathname,
          'source platform': 'portal',
          'source project': 'odin'
        }
      });
    }
  });
})(jQuery);
